// api.js
if (process.env.REACT_APP_SMART_PROFILES === 'true' && !process.env.REACT_APP_API_URL) {
  throw new Error('Smart profile previews require an explicit REACT_APP_API_URL.');
}
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.smartqrstand.com';
// Local development: http://localhost:8787/api (when using wrangler dev)
